'use client'
import {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
} from 'react'

import { useTenantConfig } from '@/hooks/queries/tenants'

import type { GetTenantConfigsResponse } from '@/services/http/tenantService/getConfigs'

export type ConfigContextProps = {
  config: GetTenantConfigsResponse | null
  isLoadingConfig: boolean
  refetchTenantConfig: () => void
}

const ConfigContext = createContext<ConfigContextProps>(
  {} as ConfigContextProps,
)

export const ConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const {
    config,
    isLoading: isLoadingConfig,
    refetchTenantConfig,
  } = useTenantConfig()

  const providerValue = useMemo(
    () => ({
      config,
      isLoadingConfig,
      refetchTenantConfig,
    }),
    [config, isLoadingConfig, refetchTenantConfig],
  )

  return (
    <ConfigContext.Provider value={providerValue}>
      {children}
    </ConfigContext.Provider>
  )
}

export const useConfig = () => {
  const context = useContext(ConfigContext)
  return context
}
